import { render, staticRenderFns } from "./FetchDraftsModal.vue?vue&type=template&id=193ed440&"
import script from "./FetchDraftsModal.vue?vue&type=script&lang=js&"
export * from "./FetchDraftsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/FetchDraftsModal.vue
// module id = null
// module chunks = 